import React, { useState, useEffect } from 'react';
import { motion, Variants } from 'framer-motion';

const container: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

const icon: Variants = {
  hidden: { opacity: 0, scale: 0.5 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { type: 'spring', stiffness: 300, damping: 20 },
  },
};

const Connections = () => {
  const [email, setEmail] = useState('');

  useEffect(() => {
    // Obfuscated email parts
    const emailName = 'contact';
    const domain = 'tanmichaelryan.com';

    // Reassemble the email
    const fullEmail = `${emailName}@${domain}`;
    setEmail(fullEmail);
  }, []);

  const links = [
    { href: 'https://gitlab.com/tanmichaelryan/', iconClass: 'bxl-gitlab', label: 'GitLab' },
    {
      href: 'https://www.linkedin.com/in/tan-michael-ryan',
      iconClass: 'bxl-linkedin',
      label: 'LinkedIn',
    },
    ...(email ? [{ href: `mailto:${email}`, iconClass: 'bx-envelope', label: 'Email' }] : []),
  ];

  return (
    <motion.div
      className="flex"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={container}
    >
      {links.map((link) => (
        <motion.a
          key={link.label}
          href={link.href}
          aria-label={link.label}
          className="group inline-block pl-4"
          target={link.href.startsWith('mailto:') ? undefined : '_blank'}
          rel="noreferrer"
          variants={icon}
          whileHover={{ scale: 1.25, rotate: 8, y: -2 }}
          whileTap={{ scale: 0.9 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20 }}
        >
          <i
            className={`bx ${link.iconClass} text-2xl transition-colors duration-300 group-hover:text-yellow`}
          ></i>
        </motion.a>
      ))}
    </motion.div>
  );
};

export default Connections;
